export default __webpack_public_path__ + "static/media/change-role.8e6a4287.svg";